import {default as cx} from "classnames"
import {Question} from "./shared/Question"
import {ScaleLegend} from "./shared/ScaleLegend"

const DEFAULT_ANSWERS = [
    {label: "1", value: "1"},
    {label: "2", value: "2"},
    {label: "3", value: "3"},
    {label: "4", value: "4"},
    {label: "5", value: "5"},
    {label: "6", value: "6"},
    {label: "7", value: "7"},
    {label: "8", value: "8"},
    {label: "9", value: "9"},
    {label: "10", value: "10"},
]

export function OneToTenPrompt({
    questionText,
    field,
    options,
    scaleStart,
    scaleEnd,
    questionNumber,
    totalQuestions,
    currentQuestion,
    data,
    emptyError,
    handle,
    sectionName,
    isRequired = true,
}) {
    const answers = options ?? DEFAULT_ANSWERS

    return (
        <>
            {sectionName && <div className="text-primary d-flex fs-6 fw-bold">{sectionName}:</div>}
            <Question questionText={questionText} questionNumber={questionNumber} totalQuestions={totalQuestions} isRequired={isRequired} />
            <div className="w-100 py-5">
                <ScaleLegend first={scaleStart ?? "1: Not Ready at All"} last={scaleEnd ?? "Ready Today: 10"} />
                <div className="btn-group w-100">
                    {answers.map((option, index) => {
                        const id = `${field}-${index}`
                        const checked = option.value === data
                        return (
                            <label
                                className={cx(
                                    "btn d-flex flex-fill flex-center btn-outline btn-active-primary px-0",
                                    emptyError ? "border-danger" : "",
                                    {active: checked}
                                )}
                                htmlFor={id}
                                key={id}
                            >
                                <input
                                    id={id}
                                    type="radio"
                                    className="btn-check"
                                    name={field}
                                    value={option.value}
                                    checked={checked}
                                    onChange={(evt) => handle(evt.target.value)}
                                />
                                {option.label}
                            </label>
                        )
                    })}
                </div>
            </div>
            {emptyError && isRequired && <span className="text-danger mt-n5">Selection is required</span>}
        </>
    )
}
